module.exports = __webpack_public_path__ + "img/partially-status.afdafaac.svg";